import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateFmtToStr, PaperComponent, statusBar } from "../../utils";
import StyledTooltip from "../shared/toolTip/StyledTooltip";
import { LuFilterX, LuRefreshCcw } from "react-icons/lu";
import { AgGridReact } from "ag-grid-react";
import {
  changeLoadingPhaseStatus,
  itemPriceStatusStart,
} from "../redux/project/projActions";
import StatusChip from "../shared/StatusChip";

const PriceStatusModal = (props) => {
  const {
    isPriceStatusDialogOpen,
    setIsPriceStatusDialogOpen,
    setOpenItemPrice,
  } = props;

  const dispatch = useDispatch();
  const pkg = useSelector((state) => state.ctrl.pkg);
  const tags = useSelector((state) => state.project.tags);
  const loadingPhase = useSelector((state) => state.project.loadingPhase);
  const itemPriceStatusData = useSelector((state) =>
    Array.isArray(state.project.itemPriceStatus)
      ? state.project.itemPriceStatus
      : []
  );

  const [gridApi, setGridApi] = useState(null);
  const [isItemLoading, setIsItemLoading] = useState(false);

  useEffect(() => {
    getItemPriceStatusData();
  }, []);

  useEffect(() => {
    if (
      loadingPhase?.action === "ITEM_PRICE_STS" &&
      loadingPhase?.phase === "START"
    ) {
      setIsItemLoading(true);
      gridApi?.showLoadingOverlay();
    }
    if (
      loadingPhase?.action === "ITEM_PRICE_STS" &&
      loadingPhase?.phase === "SUCCESS"
    ) {
      setIsItemLoading(false);
      gridApi?.hideOverlay();
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }));
    }
    if (loadingPhase?.phase === "ERROR") {
      setIsItemLoading(false);
      gridApi?.hideOverlay();
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }));
    }
  }, [loadingPhase]);

  const getItemPriceStatusData = () => {
    dispatch(
      itemPriceStatusStart({
        project_id: pkg.project_id,
        package_id: pkg.package_id,
        revision: pkg.active_revision,
      })
    );
  };

  const onGridReady = (params) => {
    setGridApi(params?.api);
  };

  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };

  const handleClosePriceStatusDialog = () => {
    setIsPriceStatusDialogOpen(false);
    setOpenItemPrice(false);
  };

  const renderTagNumber = (params) => {
    const tagNumber = tags.find(
      (tag) => tag.tag_id == params.data.tag_id
    )?.tag_number;
    if (tagNumber) {
      return tagNumber;
    } else {
      return params.data.tag_id;
    }
  };

  const statusRenderer = (params) => {
    const status = params.data.status;
    const color =
      status === "SUCCESS" ? "green" : status === "FAILED" ? "red" : "blue";
    const statusLabel =
      status === "SUCCESS"
        ? "SUCCESS"
        : status === "FAILED"
          ? "FAILED"
          : "IN PROCESS";

    return (
      <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
        <StatusChip label={statusLabel} color={color} />
      </div>
    );
  };

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false,
    sortingOrder: ["asc", "desc", " "],
    filterParams: {
      buttons: ["apply", "cancel"],
      closeOnApply: true,
    },
    menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
  };

  const columnDefs = [
    { headerName: "Tag Number", field: "tag_id", width: 135, valueGetter: renderTagNumber },
    { headerName: "Type", field: "prod_desc", width: 135 },
    { headerName: "Part Number", field: "part_number" },
    { headerName: "Request ID", width: 135, field: "batch_id" },
    {
      headerName: "Request Date",
      field: "submitted_at",
      width: 135,
      valueGetter: (row) => dateFmtToStr(row.data.submitted_at),
    },
    { headerName: "Request By", field: "submitted_by" },
    { headerName: "Status", field: "status", width: 135, cellRenderer: statusRenderer },
    { headerName: "Comments", field: "message", flex: 1 },
  ];

  return (
    <div>
      <Dialog
        open={isPriceStatusDialogOpen}
        onClose={handleClosePriceStatusDialog}
        PaperComponent={PaperComponent}
        className="viewReportStatus-model muiForm-Modal"
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="model-title mb-0 text-align-center"
          id="draggable-dialog-title"
          style={{ display: "flex" }}
        >
          <div className="header-row">
            <div>
              Price Part Status
              <StyledTooltip
                title="Refresh"
                placement="bottom"
                disableInteractive
              >
                <span
                  className={
                    isItemLoading ? "refresh-report disabled" : "refresh-report"
                  }
                  onClick={getItemPriceStatusData}
                >
                  <LuRefreshCcw
                    className={isItemLoading ? "animatonSVG" : ""}
                  />
                </span>
              </StyledTooltip>
            </div>
          </div>

          <StyledTooltip
            title={"Clear Filters"}
            placement="bottom"
            disableInteractive
            style={{ padding: "3px 0px" }}
          >
            <label>
              <LuFilterX
                className="tag-grid-head-cntrl mx-2"
                onClick={clearFilters}
                style={{ cursor: "pointer" }}
              />
            </label>
          </StyledTooltip>
        </DialogTitle>
        <DialogContent>
          <div
            className="ag-theme-alpine marginRow muiForm mb-2 pt-3"
            style={{ height: "65vh" }}
          >
            {isItemLoading && <LinearProgress />}
            <AgGridReact
              statusBar={statusBar}
              rowData={itemPriceStatusData}
              defaultColDef={defaultColDef}
              columnDefs={columnDefs}
              headerHeight={30}
              rowHeight={26}
              onGridReady={onGridReady}
              overlayLoadingTemplate={
                '<div class="loadingx" style="margin: 7em"></div> <span class="ag-overlay-loading-center " style="font-size: 18px; z-index: 100000"> Loading Rows ...</span>'
              }
            />
          </div>
        </DialogContent>
        <DialogActions className="model-actions">
          <button
            className="cnbtn btn cancel-btn"
            variant="outlined"
            onClick={handleClosePriceStatusDialog}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PriceStatusModal;
